import { Component, Input, OnInit } from '@angular/core';
import { LilateCardComponent } from '../lilate-card.component';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { KiwixiService } from '../../../kiwixi/kiwixi.service';
import { ExaminationService } from '../../../service/examination.service';
import { MaterialService } from '../../../service/material.service';
import { SharedAppState } from '../../../store/app.states';

@Component({
  selector: 'app-lilate-card-identity-issue',
  templateUrl: './lilate-card-identity-issue.component.html',
  styleUrls: ['./lilate-card-identity-issue.component.scss']
})
export class LilateCardIdentityIssueComponent extends LilateCardComponent {
  @Input() bloc: string;

  constructor(
    _router: Router,
    materialService: MaterialService,
    translateService: TranslateService,
    kiwixiService: KiwixiService,
    examinationService: ExaminationService,
    store: Store<SharedAppState>
  ) {
    super(
      _router,
      materialService,
      translateService,
      kiwixiService,
      examinationService,
      store
    )
  }
}
